<template>
  <div>
    <router-view/>
  </div>
</template>

<script lang="ts" setup>



</script>

<style lang="less">

</style>
